import LinkStreamingService from "@components/Onboarding/LinkStreamingService";

export default function LinkStreamingServiceScreen() {
  return <LinkStreamingService />;
}
